export default __webpack_public_path__ + "static/media/git.a54d3fa4.png";